<template>
    <div>
        <page-title>续费</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="站点名称" prop="name">
                    <el-input v-model="form.name" :disabled="true"/>
                </el-form-item>
                <el-form-item label="域名" prop="domain">
                    <el-input v-model="form.domain" :disabled="true"/>
                </el-form-item>
                <el-form-item label="授权凭证" prop="new_icon">
                    <app-upload v-model="form.certificate_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="年费" prop="is_year">
                    <br>
                    <el-select v-model="form.is_year" placeholder="选择年费" :disabled="true">
                        <el-option v-for="item in yearOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <template v-if="form.is_year == 2">
                    <el-form-item label="开始时间" prop="start_time">
                        <br>
                        <el-date-picker :disabled="true"
                            v-model="form.start_time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            :picker-options="{disabledDate: function(time) {
                                return time.getTime() < new Date(form.start_time).getTime()
                            }}"
                            placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="到期时间" prop="end_time">
                        <br>
                        <el-date-picker
                            v-model="form.end_time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            :picker-options="{disabledDate: function(time) {
                                return time.getTime() <= new Date(form.start_time).getTime()
                            }}"
                            placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="年费价格" prop="price">
                        <el-input type="number" min="-1" step="1" v-model="form.price"/>
                    </el-form-item>
                </template>
                <el-form-item label="备注" prop="mark">
                    <el-input v-model="form.mark"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">保存</el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped>
    .host-ip-row {
        margin-top: 25px;
    }

    .host-ip-row:first-child {
        margin-top: 0;
    }
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                year: [
                    {required: true, message: '请选择年费。'}
                ],
                price: [
                    {required: true, message: '请选择年费价格。'}
                ]
            },
            form: {
                id: null,
                name: '',
                domain: '',
                certificate_url: '',
                mark: '',
                is_year: 1,
                start_time: '',
                end_time: '',
                price: 0
            },
            yearOptions: [
                {
                    value: 1,
                    label: '免年费版'
                },
                {
                    value: 2,
                    label: '年费版'
                }
            ]
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/renew/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.detail = e.data.data
                    this.form.name = e.data.data.name
                    this.form.domain = e.data.data.domain
                    this.form.is_year = e.data.data.is_year
                    this.form.start_time = e.data.data.start_time
                    this.form.end_time = e.data.data.end_time
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/renew/update',
                        params: {
                            id: this.form.id
                        },
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/host/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
